// extracted by mini-css-extract-plugin
module.exports = {"list":"CheckMarkList_list__DVfMx"};